import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import * as layoutStyles from '../../../common/Layout/_Layout.scss'
import { Form, Row, Col, Button } from 'react-bootstrap'
import GoogleMapReact from 'google-map-react'
import HereMapsSearch from '../../../common/HereMapsSearch'
import FontAwesome from 'react-fontawesome'
import SubmitSpinner from '../../../common/Spinners/SubmitSpinner'

const helpBlockStyles = styles['help-block-font-size'] +
  ' ' + styles['margin-left-auto'] +
  ' ' + styles['margin-right-auto'] +
  ' ' + 'alert alert-danger'

class Location extends React.Component {
  constructor(props){
    super(props)
    this.addressInputContainer = React.createRef()
  }

  render () {
    const { isSearching,
            showLocationWarning,
            markerAddress,
            setMarkerAddress,
            onGoogleApiLoaded,
            initialLocation,
            initialiseMap
          } = this.props

    return (
      <Row className={commonStyles['bg-white']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section id={'locationContainer'} className={styles['no-bottom-padding']}>
            <h3>Where are you located?</h3>
            {this.props.showValidationErrors &&
              this.props.validation.help &&
              <Form.Text className={helpBlockStyles}>
                {this.props.validation.help}
              </Form.Text>}
            {showLocationWarning && <Form.Text className={helpBlockStyles}>
                Unable to determine your current location. Your device's location services may be disabled.
              </Form.Text>}
            <Row className="align-items-end">
              <Col xs={12} sm={{ span: 4, offset: 2 }} md={{ span: 3, offset: 3 }} lg={{ span: 3, offset: 3 }}>
                <Form.Group
                  ref={this.addressInputContainer}>
                  <Form.Label>Enter your address</Form.Label>
                  <HereMapsSearch
                    onPlacesChanged={this.props.placesChanged}
                    markerAddress={markerAddress}
                    setMarkerAddress={setMarkerAddress}
                    containerRef={this.addressInputContainer}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={{ span: 4, offset: 0 }} md={{ span: 3, offset: 0 }} lg={{ span: 2, offset: 0 }}>
                <Form.Group className={styles['location-label'] + ' ' + layoutStyles['no-bottom-margin']}>
                  { !isSearching && <Button variant='link' className={styles['location-button-mobile']} onClick={this.props.getLocation}>
                    <FontAwesome name='map-marker' />
                    &nbsp;
                    Use my current location
                  </Button>}
                  { isSearching && <center><SubmitSpinner /></center>}
                </Form.Group>
              </Col>
              {initialiseMap && initialLocation && <Col xs={12} sm={12} md={12} lg={12} className={styles['map-wrapper'] + ' ' + styles['no-padding']}>
                <GoogleMapReact
                  defaultCenter={initialLocation}
                  defaultZoom={6} options={createMapOptions}
                  onGoogleApiLoaded={onGoogleApiLoaded}
                  yesIWantToUseGoogleMapApiInternals />
              </Col>}
            </Row>
          </section>
        </Col>
      </Row>
    )
  }
}

export default (Location)

function createMapOptions (maps) {
  return {
    scrollwheel: false,
    gestureHandling: 'none'
  }
}
